<template >
  <div class="priceManagement-page">
    <div class="all-content-container">
      <div class="screen-all-container">
        <div style="padding: 15px; border: 1px solid #ededed">
          <h3>{{ paramName }}</h3>
          <div class="right-btn">
            <el-button type="primary" @click="handleReturn"
              >返回环境参数</el-button
            >
          </div>
        </div>
        <el-tabs
          v-model="activeName"
          @tab-click="handleClick"
          class="el-tab_top"
        >
          <el-tab-pane label="环境传感器" name="first">
            <deviceNumericalManagement></deviceNumericalManagement>
          </el-tab-pane>
          <el-tab-pane label="执行控制器" name="second">
            <deviceSwitchManagement></deviceSwitchManagement>
          </el-tab-pane>
          <el-tab-pane label="阶段控制参数" name="three">
            <stageContorlManagement></stageContorlManagement>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="pagination-container">
      <div class="pagination-content-container"></div>
    </div>
  </div>
</template>
<script>
import deviceNumericalManagement from "@/views/growthModelManagement/growthModelDeviceNumericalManagement";
import deviceSwitchManagement from "@/views/growthModelManagement/growthModelDeviceSwitchManagement";
import stageContorlManagement from "@/views/growthModelManagement/growthModelStageControlManagement";

export default {
  components: {
    deviceNumericalManagement,
    deviceSwitchManagement,
    stageContorlManagement,
  },
  data() {
    return {
      activeName: "first",
      paramName: "",
    };
  },
  created() {
    this.paramName = this.$route.query.paramName;

    if (this.$route.query.currentShow) {
      this.activeName = this.$route.query.currentShow;
    }
  },
  methods: {
    // Tab点击
    handleClick() {},
    // 返回
    handleReturn() {
      this.$router.push({
        name: `growthModelEvnParamManagement`,
        query: {
          evnId: this.$route.query.evnId,
          evnName: this.$route.query.evnName,
          groupId: this.$route.query.groupId,
        },
      });
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
.el-button {
  line-height: 0 !important;
}
.el-table {
  overflow: auto !important;
}
.right-btn {
  margin-top: -30px;
  float: right;
  margin-right: 10px;
}
</style>